import { render, staticRenderFns } from "./DatosAdicionales.vue?vue&type=template&id=589ecb20&scoped=true&lang=html&"
import script from "./DatosAdicionales.vue?vue&type=script&lang=js&"
export * from "./DatosAdicionales.vue?vue&type=script&lang=js&"
import style0 from "./DatosAdicionales.vue?vue&type=style&index=0&id=589ecb20&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589ecb20",
  null
  
)

export default component.exports